import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { ClientCodeService } from '@modules/dashboard/client-code.service';
import { map } from 'rxjs';

export const clientCodeGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const clientCodeService = inject(ClientCodeService);
  const router = inject(Router);

  const requestedClientCode = route.params.clientCode;

  // Let departments load in the background; the page renders immediately and
  // guards that need departments await them.
  return clientCodeService.switchTo(requestedClientCode).pipe(
    map((clientCode) => {
      if (!clientCode) {
        return router.createUrlTree(['/disabled-account']);
      }

      if (clientCode !== requestedClientCode) {
        return router.createUrlTree(['/client', clientCode, 'sequences']);
      }

      return true;
    }),
  );
};
